import { captureException } from '@sentry/node';

import { doRequest } from '@r1-frontend/do-request/index';
import { addCard } from '@r1-frontend/api-domru/api-pay/v1/card/add';
import { IRegPayCard } from '@r1-frontend/api-domru/api-pay/v1/card/dto/IRegPayCard';
import { makePaymentAuth, makePaymentUnauth } from '@r1-frontend/api-domru/api-pay/v1/payment/add';

import { setInProcess } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { IPaymentResult, setPaymentResult } from '~/src/features/payments-abn/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';

const payByNewCard = (amount: number) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        dispatch(setInProcess(true));

        const {
            auth: { isAuth },
            city: { provider: { providerId } },
            payment: { isSaveCard, result },
        } = getState();

        const requestParams = {
            save_card_flag: +isSaveCard,
            autopay_act: 0,
            email: '',
            payment_value: amount,
            payment_source: 1,
            return_url: location.origin + '/payments-response?',
        };
        const return_url = location.origin + '/payments-response?';
        const resp = await doRequest.apiPay<IRegPayCard>(
            amount
                ? isAuth
                    ? makePaymentAuth(providerId, requestParams)
                    : makePaymentUnauth(providerId, requestParams)
                : addCard(providerId, { autopay_act: 0, return_url, payment_source: 1 }),
        );

        if (resp.isSuccess) {
            const respData: IPaymentResult = {
                ...result,
                frameUrl: resp.payload.payUrl,
            };
            dispatch(setPaymentResult(respData));
        } else {
            captureException(resp);
        }

        dispatch(setInProcess(false));
    };
};

export default payByNewCard;
